export function added<T>(s: Set<T>, item: T): Set<T> {
  return new Set(s).add(item);
}

export function deleted<T>(s: Set<T>, item: T): Set<T> {
  const newSet = new Set(s);
  newSet.delete(item);
  return newSet;
}

export function getLast<T>(s: Set<T>): T | null {
  let lastItem: T | null = null;
  s.forEach((item) => {
    lastItem = item;
  });
  return lastItem;
}
